import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Buffer } from "buffer";
import "./index.css";
import "./icons";
import App from "./App";
import "./styles/styles.css";

window.Buffer = Buffer;

const rootElement = document.getElementById("root") as HTMLElement;

// Check if the root has already been rendered by react-snap
const hasChildNodes = rootElement.hasChildNodes();

if (hasChildNodes) {
  // Use hydrate for pre-rendered content (react-snap)
  ReactDOM.hydrateRoot(
    rootElement,
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  );
} else {
  // Use createRoot for client-side only rendering
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  );
}
